import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-user-single',
  templateUrl: './user-single.component.html',
  styleUrls: ['./user-single.component.css']
})
export class UserSingleComponent implements OnInit {

  constructor(private route: ActivatedRoute, private afs: AngularFirestore) {}
  id: any;
  user: any = [];
  premiumlist: any;
  ngOnInit() {
    this.route.paramMap.subscribe(id => {
      this.id = id['params']['id'];
      const user = this.afs.doc(`/users/${this.id}`).valueChanges().subscribe( userdata => {
        this.user = userdata;
      });
    });

    this.afs.collection('PremiumCollection', res => {
      return res.where('userid', '==', this.id);
    }).valueChanges().subscribe(details => {
      console.log(details);
      this.premiumlist = details;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/users/user-single/user-single.component.ts